module.exports = __webpack_public_path__ + "static/media/playStore.424d6292.png";